import { lineShadowPlugin } from '@core/configs/chart-js.config';
import { Chart } from 'chart.js';

Chart.register(lineShadowPlugin);
